<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Audit Trails",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Audit Trails",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Audit Trails",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "activity",
          sortable: true,
          label: "ACTIVITY",
        },
        {
          key: "cat",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "user",
          sortable: true,
          label: "USER",
        },
        {
          key: "createddate",
          sortable: true,
          label: "DATE/TIME",
        },
      ],
      data: {
        dto: moment(new Date()).format("YYYY-MM-DD"),
        dfrom: "",
        type: 10,
      },
      types: [
        {name: "All Types",id: 10},
        {name: "Authentication",id: 1},
        {name: "Sale",id: 2},
        {name: "Stock",id: 3},
        {name: "ManageMent",id: 4},
        {name: "Finance",id: 5},
      ],
      filterTitle: "",
      filteredReport: [],
    };
  },
  computed: {
    ...mapState("general", ["audits"]),
    ...mapGetters("general", ["Audits"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredReport ? this.filteredReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  watch: {
    audits(newValue) {
      if (newValue.data.length > 0) {
        this.assiginData();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Audits ? this.Audits.length : 1;
  },
  methods: {
    ...mapActions({
      FetchAudits: "general/fetchAudits",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    assiginData() {
      this.filteredReport = this.Audits;
    },

    filterReport() {
      let date2 = this.data.dto;
      let date1 = this.data.dfrom;
      this.filteredReport = this.Audits.filter((element) => {
        if (this.data.type != 10 && this.data.dfrom == "" && this.data.dto != "") {

          return element.type == this.data.type && element.date <= date2;
        } else if (
          this.data.type == 10 &&
          this.data.dfrom != "" &&
          this.data.dto != ""
        ) {

          return element.date >= date1 && element.date <= date2;
        }
        else if (
          this.data.type == 10 &&
          this.data.dfrom == "" &&
          this.data.dto != ""
        ) {

          return element.date <= date2;
        } else if (
          this.data.type != 10 &&
          this.data.dfrom != "" &&
          this.data.dto != ""
        ) {

          return (
            element.type== this.data.type &&
            element.date >= date1 &&
            element.date <= date2
          );
        }
      });
    },
  },
  created() {
    this.FetchAudits();
    this.assiginData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>Type</label>
                  <model-list-select
                    :list="types ? types : []"
                    v-model="data.type"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Audit Category"
                    @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>From</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dfrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>To</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dto"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="filteredReport ? filteredReport : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(cat)="data">
                  <span v-if="data.item.type==1">Authentication</span>
                  <span v-if="data.item.type==2">Sale</span>
                  <span v-if="data.item.type==3">Stock</span>
                  <span v-if="data.item.type==4">ManageMent</span>
                  <span v-if="data.item.type==5">Finance</span>
                </template>
              </b-table>
            </div>
            <Loader v-if="!Audits"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
